import React, {useState, useRef, forwardRef, useImperativeHandle} from 'react';
import {
  Button,
  Card,
  Checkbox,
  Chip,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {CloseIcon} from 'yet-another-react-lightbox';
import {useFieldArray, Controller, useForm} from 'react-hook-form';
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
// import {useOnlineContext} from './OnlineTestContext';
interface Blank {
  id: number;
  placeholder: string;
  answers: string;
  matchType: 'contains' | 'exact';
  caseSensitive: boolean;
}
interface DescriptiveQuestionTypeProps {
  question?: string;
  // eslint-disable-next-line react/boolean-prop-naming
  enforceWordLimit?: boolean;
  wordLimit?: number | undefined;
  setEnforceWordLimit?: (value: boolean) => void;
  setQuestion?: (value: string) => void;
  setWordLimit?: (value: number) => void;
  type?: string;
  handleEditQuestion?: any;
}
interface ChildFormMethods {
  submitForm?: () => Promise<any>;
}
const schema = yup.object().shape({
  QuestionText: yup.string().required('Question is required'),
  descriptive_enforce_word_limit_length: yup
    .number()
    .nullable()
    .test(
      'enforce-limit',
      'Word limit is required and cannot exceed 5000',
      function (value) {
        const {descriptive_enforce_word_limit} = this.parent;
        if (descriptive_enforce_word_limit) {
          return value !== null && value !== undefined && value <= 5000;
        }
        return true;
      }
    ),
  descriptive_enforce_word_limit: yup.boolean()
});
const FillInTheBlank = forwardRef<
  ChildFormMethods,
  DescriptiveQuestionTypeProps
>(({question, handleEditQuestion}, ref) => {
  //   const {onlineData, setOnlineData} = useOnlineContext();
  const [blanks, setBlanks] = useState<Blank[]>([]);
  const [nextId, setNextId] = useState(1);
  const contentRef = useRef<HTMLDivElement>(null);
  const {
    control,
    handleSubmit,
    watch,
    clearErrors,
    setValue,
    trigger,
    getValues,
    formState: {errors}
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      QuestionText: handleEditQuestion?.QuestionText || ''
    }
  });
  console.log('contentRef', contentRef);
  console.log('blanksess', blanks);
  const handleBlankChange = (id: number, field: keyof Blank, value: any) => {
    setBlanks(
      blanks.map(blank =>
        blank.id === id ? {...blank, [field]: value} : blank
      )
    );
  };
  const handleDeleteBlank = (id: number) => {
    //i want to remove the blank with the id from the contentEditable div
    console.log('id', id);
    console.log('blanks', blanks);
    const updatedBlanks = blanks.filter(blank => blank.id !== id);

    setBlanks(updatedBlanks);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Backspace') {
      const selection = window.getSelection();
      const range = selection?.getRangeAt(0);
      console.log('seletce', selection);
      console.log(
        'range.startContainer.nodeType',
        range?.commonAncestorContainer,
        range?.endContainer,
        range?.startContainer
      );
      if (range && contentRef.current) {
        const {startContainer} = range;
        console.log('startContainer', startContainer);
        // Check if the previous sibling is a chip
        const previousNode =
          range.startContainer instanceof Text
            ? range.startContainer.parentNode?.previousSibling
            : range.startContainer.previousSibling;
        console.log('previousNode', previousNode);
        if (previousNode instanceof HTMLElement && previousNode.dataset.id) {
          const chipId = previousNode.dataset.id;

          // Prevent default backspace behavior and delete the chip
          event.preventDefault();
          handleDeleteBlank(Number(chipId));
        }

        // Handle edge case where the cursor is inside an empty text node
        if (
          startContainer.nodeType === Node.TEXT_NODE &&
          startContainer.textContent === ''
        ) {
          const parent = startContainer.parentNode;
          const siblingNode = parent?.previousSibling;
          if (siblingNode instanceof HTMLElement && siblingNode.dataset.id) {
            const chipId = siblingNode.dataset.id;
            event.preventDefault();
            handleDeleteBlank(Number(chipId));
          }
        }
      }
    }
  };

  const handleInsertBlank = () => {
    const newLabel = `Blank (${nextId})`;
    const newBlank: Blank = {
      id: nextId,
      placeholder: newLabel,
      answers: '',
      matchType: 'exact',
      caseSensitive: false
    };
    setBlanks([...blanks, newBlank]);
    setNextId(nextId + 1);
  };
  useImperativeHandle(ref, () => ({
    submitForm: () =>
      new Promise((resolve, reject) => {
        handleSubmit(data => {
          console.log('Child Form Data:', data);
          resolve(data); // Resolve the promise with form data
        })();
      })
  }));
  return (
    <Card variant="outlined" sx={{mx: 'auto', padding: '1vh'}}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1vh'
        }}>
        <Typography variant="h5">Question</Typography>
        <Button onClick={handleInsertBlank} variant="contained" color="primary">
          Insert Blank
        </Button>
      </div>
      <div
        ref={contentRef}
        contentEditable={true}
        onKeyDown={handleKeyDown}
        style={{border: '1px solid #ccc', padding: '8px'}}>
        {blanks.map((blank, index) => (
          // <span key={blank.id} contentEditable="false" className="zpl_tg">
          //   {blank.placeholder}
          //   <IconButton
          //     onClick={() => handleDeleteBlank(blank.id)}
          //     color="error">
          //     <DeleteIcon />
          //   </IconButton>
          // </span>
          <Chip
            contentEditable="false"
            size="small"
            variant="soft"
            label={`Blank ${index + 1}`}
            key={blank.id}
            onDelete={() => handleDeleteBlank(Number(blank.id))}
            color="primary"
            style={{margin: '5px'}}
            data-id={blank.id.toString()} // Adds a unique identifier for the chip
            role="chip"
          />
        ))}
      </div>
      {blanks.map((blank, index) => (
        <Card
          variant="outlined"
          key={blank.id}
          sx={{mx: 'auto', mt: 3, padding: '1vh'}}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '0.5vh'
            }}>
            <Typography variant="h6">
              Configure {`Blank ${index + 1}`}
            </Typography>
            <IconButton
              onClick={() => handleDeleteBlank(blank.id)}
              color="error">
              <DeleteIcon />
            </IconButton>
          </div>
          <TextField
            fullWidth
            label="Answers (comma-separated)"
            variant="outlined"
            value={blank.answers}
            onChange={e =>
              handleBlankChange(blank.id, 'answers', e.target.value)
            }
            sx={{mb: 1}}
          />
          <RadioGroup
            row
            value={blank.matchType}
            onChange={e =>
              handleBlankChange(blank.id, 'matchType', e.target.value)
            }>
            <FormControlLabel
              value="contains"
              control={<Radio />}
              label="Contains"
            />
            <FormControlLabel
              value="exact"
              control={<Radio />}
              label="Exact match"
            />
          </RadioGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={blank.caseSensitive}
                onChange={e =>
                  handleBlankChange(blank.id, 'caseSensitive', e.target.checked)
                }
              />
            }
            label="Case sensitive"
          />
        </Card>
      ))}
    </Card>
  );
});

export default FillInTheBlank;
